import React from 'react'
import { Grid } from '@material-ui/core'
import SimpleModal from '../../../components/Modals/SimpleModal'
import RoundedButton from '../../../components/Actions/RoundedButton'
import LineInputForm from '../../../components/Forms/LineInputForm'
import LineSelectForm from '../../../components/Forms/LineSelectForm'
import SwitchForm from '../../../components/Forms/SwitchForm'

const EditExhibitionModal = ({ open, form, onChange, onSubmit, onClose, content }) => {

    return (
        <SimpleModal maxWidth='sm' open={open} onClose={onClose}>
            <Grid container alignItems='center' spacing={4}>
                <Grid item xs={12} sm={6}>
                    <LineInputForm data={form.title} onChange={onChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LineSelectForm data={form.magazine_type_id} onChange={onChange} />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <LineInputForm data={form.min_artwork_number} onChange={onChange} />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <LineInputForm data={form.max_artwork_number} onChange={onChange} />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <SwitchForm data={form.featured} onChange={onChange} />
                </Grid>
                <Grid item xs={12}>
                    <LineInputForm data={form.description} onChange={onChange} />
                </Grid>
                <Grid item xs></Grid>
                <Grid item>
                    <RoundedButton size='small' onClick={() => onSubmit('general_info')}>
                        {content.save_button}
                    </RoundedButton>
                </Grid>
            </Grid>
        </SimpleModal>
    )
}

export default EditExhibitionModal